// removed by extract-text-webpack-plugin
module.exports = {"Maze":"Maze-cssmodule-Maze-1zQrt","title":"Maze-cssmodule-title-_MCvF","CHARACTER_TEXT":"Maze-cssmodule-CHARACTER_TEXT-r2_7c","characterImage":"Maze-cssmodule-characterImage-3j7bY","BLOCK":"Maze-cssmodule-BLOCK-EpNqP","mapHint":"Maze-cssmodule-mapHint-9AUWP","layout3":"Maze-cssmodule-layout3-24StK","IMAGE":"Maze-cssmodule-IMAGE-ypT4A","guide":"Maze-cssmodule-guide-17KhP","contentTitle":"Maze-cssmodule-contentTitle-4nLua","htmlContent":"Maze-cssmodule-htmlContent-252gk","image":"Maze-cssmodule-image-3ozK7","layout1":"Maze-cssmodule-layout1-148r-","layout2":"Maze-cssmodule-layout2-2x95e"};


//////////////////
// WEBPACK FOOTER
// ./themes/CP2017S2/Maze.cssmodule.less
// module id = 683
// module chunks = 0